import { ImportedInvoiceExtraction } from '@features/importedInvoices/types/importedInvoiceExtraction'
import { ImportedInvoiceReviewLineValues } from '@features/importedInvoices/types/importedInvoiceReviewFormSchema'
import { getImportedInvoiceVatRate } from '@features/importedInvoices/utils/getImportedInvoiceVatRate'
import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { getDefaultImportedInvoiceReviewLine } from './getDefaultImportedInvoiceReviewLine'

/**
 * A proposed rate the VAT rate picker would not show — not the organization's, or not a sales rate —
 * is left empty, so approve asks the reader to pick one. Without `taxRates` (the request failed)
 * the proposal is kept, and approve reports the rate it cannot calculate the VAT amount from.
 */
const getVatRateId = (taxRates: TaxRate[] | undefined, taxRateId?: string | null): string | null => {
  if (!taxRateId) {
    return null
  }

  if (!taxRates) {
    return taxRateId
  }

  return getImportedInvoiceVatRate(taxRates, taxRateId) === null ? null : taxRateId
}

/** Pass the rates including deactivated ones, which the VAT rate picker still shows when selected. */
export const getImportedInvoiceReviewLines = (
  extraction: ImportedInvoiceExtraction,
  taxRates: TaxRate[] | undefined,
): ImportedInvoiceReviewLineValues[] => {
  const { lines, proposal } = extraction
  const revenueEntryLines = proposal?.entryLines?.filter((entryLine) => entryLine.side === 'credit') ?? []

  if (revenueEntryLines.length) {
    return revenueEntryLines.map((entryLine) => ({
      amountExclVat: entryLine.amountExclTax ?? null,
      categoryId: entryLine.accountId ?? null,
      description: entryLine.description ?? '',
      vatRateId: getVatRateId(taxRates, entryLine.taxRateId),
    }))
  }

  if (lines?.length) {
    return lines.map((line) => ({
      ...getDefaultImportedInvoiceReviewLine(),
      amountExclVat: line.amountExclVat ?? null,
      description: line.description ?? '',
    }))
  }

  return [getDefaultImportedInvoiceReviewLine()]
}
